import React from "react";
import { useState, useEffect } from "react";
import QuantityControl from "./QuantityControl";
import AddonList from "./AddonList";
import useFoodItemState from "./useFoodItemState";
import "./FoodItem.css";
import { calculateTotalPrice } from "./foodItemLogic";
import UnavavailableReasonModal from "../../components/UnavailableReasonModal/UnavailableReasonModal";
import { syncQuantitiesBySequence } from "./../../components/FoodModal/foodItemLogic";
import FoodActionButton from "./FoodActionButton";
import UnauthorizeLogin from "./UnauthorizeLogin";
import useLoginState from "./useLoginState";
export default function FoodItem({
  food,
  mode,
  initialSelections,
  orderType,
  isPreview,
  handleClose,
  selectedItemInCart,
  showUnavailableReasonModal,
  setShowUnavailableReasonModal,
  setShowOutOfHourModal,
  onAfterSaveInSearch
}) {
  const {
    quantity,
    selectedAddons,
    handleQuantityChange,
    handleAddonQuantityChange,
    handleAddonToggle,
    // handleOptionToggle,
    handleOptionQuantityChange,
    handleSubOptionChange,
    handleAddToCart,
    handleEditFoodItem,
    handleRadioOptionToggle,
    handleCheckboxOptionToggle,
    instruction,
    setInstruction,
    handleDeleteItem,
  } = useFoodItemState(food, handleClose, orderType, initialSelections);
  const { loginModalOpen, hideModalInfo, userDetails, showModalInfo } =
    useLoginState();

  useEffect(() => {
    if (selectedItemInCart?.foodItem?.instructions) {
      setInstruction(selectedItemInCart?.foodItem.instructions);
    }
  }, [selectedItemInCart?.foodItem?.instructions]);

  const [loading, setLoading] = useState(false);
  const totalPrice = calculateTotalPrice(food, quantity, selectedAddons);

  const handleSave = async ({ isConfirm, allergyNote } = {}) => {
    setLoading(true);
    if (mode === "edit") {
      const syncedData = syncQuantitiesBySequence(
        selectedItemInCart,
        selectedAddons
      );
      await handleEditFoodItem(syncedData, selectedItemInCart);
    } else {
      await handleAddToCart({ isConfirm, allergyNote });
    }
    setLoading(false);
  };

  return (
    <div className='food-item'>
      <AddonList
        addons={food?.addOns}
        foodItemQuantity={quantity}
        selectedAddons={selectedAddons}
        onAddonQuantityChange={handleAddonQuantityChange}
        onAddonToggle={handleAddonToggle}
        onRadioOptionToggle={handleRadioOptionToggle}
        onCheckboxOptionToggle={handleCheckboxOptionToggle}
        onOptionQuantityChange={handleOptionQuantityChange}
        onSubOptionChange={handleSubOptionChange}
      />
      <QuantityControl
        mode={mode}
        value={quantity}
        onIncrease={() => handleQuantityChange(+1)}
        onDecrease={() => handleQuantityChange(-1)}
        handleDeleteItem={handleDeleteItem}
        selectedItemInCart={selectedItemInCart}
      />

      {/* Show for  Special instruction on FoodCart*/}
      <div className='pb-5'>
        <h5 className=' titleColor'>Special instruction</h5>
        <div className=''>
          <input
            type='text'
            className='form-control inputField'
            value={instruction}
            onChange={(e) => {
              setInstruction(e.target.value);
            }}
            placeholder='Enter any special instructions...'
          />
        </div>
      </div>

      {showUnavailableReasonModal && (
        <UnavavailableReasonModal
          setShowUnavailableReasonModal={setShowUnavailableReasonModal}
          foodItemName={food.itemName}
          foodUnavailableReason={food.foodUnavailableReason}
          sectionUnavailableReason={food.sectionUnavailableReason}
          menuUnavailableReason={food.menuUnavailableReason}
        />
      )}

      <FoodActionButton
        loading={loading}
        food={food}
        mode={mode}
        totalPrice={totalPrice}
        handleSave={handleSave}
        isPreview={isPreview}
        setShowUnavailableReasonModal={setShowUnavailableReasonModal}
        setShowOutOfHourModal={setShowOutOfHourModal}
        userDetails={userDetails}
        showModalInfo={showModalInfo}
        onAfterSaveInSearch={onAfterSaveInSearch}
      />

      {/* Login modal for unauthorized user */}
      <UnauthorizeLogin
        loginModalOpen={loginModalOpen}
        handleCloseLogin={hideModalInfo}
      />
    </div>
  );
}
